import { APP_INITIALIZER, inject } from '@angular/core';
import { ConfigStateService, RoutesService } from '@abp/ng.core';
import { FATURAMENTO_BASE_ROUTES } from './faturamento-base.routes';
import { addRoutesWhenAnyFeatureEnabled } from '../../shared/routes/feature-routes.util';

export const FATURAMENTO_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: configureRoutes,
  },
];

function configureRoutes() {
  const routesService = inject(RoutesService);
  const configState = inject(ConfigStateService);

  return () => {
    // Faturamento acende com FlowPay OU Confirmação de Entregas.
    addRoutesWhenAnyFeatureEnabled(
      routesService,
      configState,
      ['cargo_fleet.FlowPay', 'cargo_fleet.ConfirmacaoEntregas'],
      [...FATURAMENTO_BASE_ROUTES],
    );
  };
}
